import styled from "styled-components";
import { media } from "../../../../utils";

export const HeaderContentCard = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderText = styled.span`
  color: ${({ theme }) => theme.color.neutral["03"]};
  margin-bottom: 0;
`;

export const DataText = styled.span`
  color: ${({ theme }) => theme.color.brandPrimary.medium};
  margin-bottom: 0;
`;

export const TimeLineItemIcon = styled.svg(() => ({
  marginRight: "18px",
}));

export const CalendarIcon = styled.svg(({ theme }) => ({
  marginRight: "12px",
  color: theme.color.brandPrimary.medium,
}));

export const TimeLineItem = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  position: "relative",
  top: "-4px",
  left: "-8px",
  svg: {
    backgroundColor: theme.color.neutral["08"],
    color: theme.color.brandPrimary.light,
  },
}));

export const TimeLine = styled.ul(({ theme }) => ({
  li: {
    marginLeft: "8px",
    paddingBottom: "20px",
    position: "relative",
    borderLeft: `1px solid ${theme.color.brandPrimary.light}`,
    "&:last-of-type": {
      borderLeftStyle: "dashed",
      paddingBottom: "10px",
    },
  },
}));

export const CalendarioAssembleiaCardTitle = styled.span(({ theme }) => ({
  color: theme.color.neutral["02"],
}));

export const CalendarioAssembleiaCard = styled.div(() => ({
  "& > .Card__Body": {
    color: "inherit !important",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    minHeight: "220px",
  },
  [media.lg()]: {
    maxWidth: "384px",
  },
}));

export const CalendarioAssembleiaCardSwitch = styled.div(() => ({
  [media.lg()]: {
    "& > .Card__Body": {
      display: "flex",
    },
    "& .SwitchContent": {
      margin: "0 16px",
    },
  },
}));

export const MoreItensFooterLabel = styled.span`
  margin-bottom: 4px;
`;

export const MoreItensFooterIcon = styled.svg`
  margin-bottom: 4px;
`;

export const MoreItensFooterCard = styled.div`
  & .Card__Body {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .Card__Body > div {
    width: 100%;
    max-width: 90%;
  }
`;

export const MoreItensFooter = styled.a(({ theme }) => ({
  width: "100%",
  height: "100%",
  textDecoration: "none !important",
  "&.expanded": {
    [`${MoreItensFooterIcon}`]: {
      transform: "rotate(180deg)",
    },
  },
  "&.disabled": {
    [`${MoreItensFooterCard}`]: {
      "& .Card__Body": {
        color: `${theme.color.neutral["03"]} !important`,
      },
    },
  },
}));
